import { render, staticRenderFns } from "./CustomFieldText.vue?vue&type=template&id=324b93f2"
import script from "./CustomFieldText.vue?vue&type=script&lang=js"
export * from "./CustomFieldText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports